import(/* webpackMode: "eager" */ "/var/www/chaivio-web-ecart/app/loading.tsx")